import UserTable from 'components/UserTable/UserTable';
import { IUser } from 'types/interfaces/iUser';
import EmptyState from '../../components/EmptyState';
import withLoadingState from '../../helpers/withLoadingState';

interface UserManagementContentProps {
  selectedTab: string;
  users: IUser[];
}

const UserManagementContent = ({ users, selectedTab }: UserManagementContentProps) => (
  <>
    {users.length ? (
      <UserTable rows={users} selectedTab={selectedTab} />
    ) : (
      <EmptyState type={`user_management_${selectedTab}`} />
    )}
  </>
);

export default withLoadingState(UserManagementContent);
